import { render, staticRenderFns } from "./ContentAddInPPT.vue?vue&type=template&id=654f6134&scoped=true&"
import script from "./ContentAddInPPT.vue?vue&type=script&lang=js&"
export * from "./ContentAddInPPT.vue?vue&type=script&lang=js&"
import style0 from "./ContentAddInPPT.vue?vue&type=style&index=0&id=654f6134&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "654f6134",
  null
  
)

export default component.exports